import { useTheme } from '@gripp/shared-logic';
import {
  createBaseTheme,
  Colors,
  KeyboardSafeView,
  Layout,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { PaperProvider } from 'react-native-paper';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { ShareView } from '../issues/components/shareView';

/**
 * Signed-out `/share/:token`. Brings the same canvas chrome as
 * `anonymousAsset.tsx` (no dashboard Layout, no sidebar) around the ordinary
 * share view in its anonymous mode — read-only header, composer on, replies
 * attributed as the sharer's guest.
 */
export const AnonymousShareView = () => {
  const { resolvedTheme } = useTheme();

  return (
    <PaperProvider theme={createBaseTheme(false, resolvedTheme)}>
      <SafeAreaProvider>
        <KeyboardSafeView style={styles.containerKeyboard}>
          <View style={styles.page} testID="anonymous-share-view">
            <ShareView anonymous />
          </View>
        </KeyboardSafeView>
      </SafeAreaProvider>
    </PaperProvider>
  );
};

const styles = StyleSheet.create({
  containerKeyboard: {
    ...Layout.container,
  },
  page: {
    flex: 1,
    width: '100%',
    backgroundColor: Colors.role.canvas,
  },
});
